import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import Table from '../../../components/ProposalStatsPage/Table';

const mapStateToProps = (state: StoreState) => {
	const {
		proposalStats: { proposalStatus, allIds },
	} = state;

	return {
		proposalStatus,
		allIds,
	};
};

export default connect(mapStateToProps)(Table);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProposalStatsPage/Table/index.tsx